import {combineReducers} from "redux";
import {AppState, appStateReducer} from "./current-user-reducer";
import {FileUploadState, uploadFileReducer} from "./file-upload-reducer";
import {ModalState, modalStateReducer} from "./modal-reducer";
import {mediaAlbumReducer, MediaAlbumState} from "./media-album-reducer";


export interface RootState {
    appState: AppState,
    uploadFiles: FileUploadState,
    modalState: ModalState
    albumState: MediaAlbumState
}

export const rootReducer = combineReducers<RootState>({
    appState: appStateReducer,
    uploadFiles: uploadFileReducer,
    modalState: modalStateReducer,
    albumState: mediaAlbumReducer
})
